import React from "react";
import './CustomIconButton.scss'
import { ICustomIconButton } from "@types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const CustomIconButton: React.FC<ICustomIconButton> = (props) => {

    return <button className="query-editor-custom-icon-button-container"
        onClick={(e) => {
            props?.onClick?.()
        }}
    >
        <FontAwesomeIcon icon={props.icon} />
    </button>
}